import { COUNTRY_CODE } from '@cemex-core/cmx-api';

export const RMXCOUNTRIES = [COUNTRY_CODE.MEXICO, COUNTRY_CODE.COLOMBIA];
